/**
 * evenements.js
 */

// Import
import "./evenements.scss";
import $ from 'jquery';

$(document).ready(function() {

});